import { allBudgetStructuresOptions, allBudgetTypesOptions, allClassificationTypesOptions, allDataSourcesOptions, allDevelopTypesOptions, allExpenseTypesOptions, allIncomeClassificators, allMeasureUnitsOptions, allMutuallyRedeemingOptions, allPeriodicitiesOptions, allReportNamesOptions, allReportTypesOptions, allMutuallyRedeemingLevelOptions, allSegmentationOptions, allStatusOptions } from "../../common/baseOptions"
import { Classificator } from "../../common/types/Classificator"
import { ByForm } from "../../common/types/roots/fields"
import { Option } from "../../common/types/Option"
import { Indicator } from "../../common/types/Indicator"
import { Template } from "../../common/types/Template"
import { Report127DailyFilterOptions } from "./options/Report127DailyFilterOptions"
import { Report127DailyFilterSettings } from "./settings/Report127DailyFilterSettings"
import { cloneDeep } from 'lodash'

export const report127DailyExpenses: Classificator[] = [
    { key: 'gr',  active: false, selected: [] },
    { key: 'pgr', active: false, selected: [] },
    { key: 'abp', active: false, selected: [] },
    { key: 'prg', active: false, selected: [] },
    { key: 'ppr', active: false, selected: [] },
    { key: 'pcl', active: false, selected: [] },
    { key: 'spf', active: false, selected: [] }
]
export const report127DailyIndicators: Indicator[] = [
    { key: 'utv', active: true },
    { key: 'utch', active: true },
    { key: 'plg', active: true },
    { key: 'plgs', active: true }, // Родительнский показатель для plgp, plgo
    { key: 'obz', active: true },
    { key: 'nobz', active: true },
    { key: 'sumrg', active: true },
    { key: 'percentage1', active: true },
    { key: 'percentage2', active: true }
]

// Разрезность по умолчанию: только КБК активно
const defaultSegmentations = cloneDeep(allSegmentationOptions).map(s => ({
    ...s,
    active: s.value === 'KBK'
}))

// Статус по умолчанию: 39 - Утверждено в ИС КК
const defaultStatuses = cloneDeep(allStatusOptions).filter(s => s.value === '39')

// Варианты byForm для 1-27-DAILY
export const report127DailyByFormOptions: Option<ByForm>[] = [
    { value: '5-42', label: '2-19 и 5-42' },
    { value: '4-20', label: '2-19 и 4-20' },
]

const fs: Report127DailyFilterSettings = {
    reportName: '1-27-DAILY',

    reportType: 'REGULATED',
    classificationType: 'MIXED',
    dataSource: 'IISK',
    periodicity: 'DAY',

    date: '',
    regions: [],
    segmentations: defaultSegmentations,
    statuses: ['39'],
    byForm: { value: '5-42', label: '2-19 и 5-42' },
    mutuallyRedeeming: 'ONLY',
    mutuallyRedeemingLevels: [],
    budgetTypes: [],
    measureUnit: 'TENGE',
    budgetStructure: "WITH",
    developType: null,
    roundUpTo: null,
    incomeTotal: false,
    expenseTotal: false,
    expenseType: 'FUNCTIONAL',
    incomes: cloneDeep(allIncomeClassificators),
    expenses: cloneDeep(report127DailyExpenses),
    indicators: cloneDeep(report127DailyIndicators),
    isTree: true
}

export const report127DailyBaseTemplate: Template = {
    id: null,
    name: 'Отчет 1-27 (ежедневный)',
    excelName: null,
    description: null,
    category: '10',
    regions: [],
    userId: '',
    filterSettings: fs
}

export const report127DailyFilterOptions: Report127DailyFilterOptions = {
    // Base:
    key: '1-27-DAILY',
    reportNames: cloneDeep(allReportNamesOptions),
    reportTypes: cloneDeep(allReportTypesOptions),
    classificationTypes: cloneDeep(allClassificationTypesOptions),
    dataSources: cloneDeep(allDataSourcesOptions).filter(it => it.value !== 'MIXED'),
    // Custom:
    regions: [], // Загружается с бэка
    segmentations: cloneDeep(allSegmentationOptions),
    statuses: cloneDeep(allStatusOptions),
    byForms: cloneDeep(report127DailyByFormOptions),
    mutuallyRedeeming: cloneDeep(allMutuallyRedeemingOptions),
    mutuallyRedeemingLevels: cloneDeep(allMutuallyRedeemingLevelOptions),
    periodicities: [{ value: 'DAY', label: 'Ежедневный', labelKk: 'Күнделікті', labelEn: 'Daily' }],
    budgetTypes: cloneDeep(allBudgetTypesOptions).filter(it => it.value !== 1),
    measureUnits: cloneDeep(allMeasureUnitsOptions),
    budgetStructures: cloneDeep(allBudgetStructuresOptions),
    developTypes: cloneDeep(allDevelopTypesOptions),
    expenseTypes: cloneDeep(allExpenseTypesOptions),
    incomes: cloneDeep(allIncomeClassificators),
    expenses: cloneDeep(report127DailyExpenses)
}
